import React from 'react'
import arrayDestruct from '../assets/portfolio/arrayDestruct.jpg'
import installNode from '../assets/portfolio/installNode.jpg'
import navbar from '../assets/portfolio/navbar.jpg'
import reactParallax from '../assets/portfolio/reactParallax.jpg'
import reactSmooth from '../assets/portfolio/reactSmooth.jpg'
import reactWeather from '../assets/portfolio/reactWeather.jpg'
import matlab from '../assets/portfolio/Matlab.jpg'
import ecom from '../assets/portfolio/E-com.jpg'

const Portfolio = () => {

    const portfolios = [
        {
            id: 1,
            src:arrayDestruct
        },
        {
            id: 2,
            src:installNode
        },
        {
            id: 3,
            src:navbar
        },
        {
            id: 4,
            src:matlab
        },
        {
            id: 5,
            src:reactSmooth
        },
        {
            id: 6,
            src:reactWeather
        },
    ]

    return (
  
        <div name="portfolio"
            className="bg-gradient-to-b from-black to to-gray-800 w-full text-white md:h-screen pt-96"
        >
            <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
                <div className="pb-8">
                    <p className="text-4xl font-bold inline border-b-4 border-gray-500 ">Portfolio</p>
                    <p className="py-6">CheckOut some of my Previous Projects</p>
                </div>

                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
    
                {
                    portfolios.map(({id,src})=>(
                        <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
                
             
                    <img src={src} alt=""
                        className="rounded-md duration-200 hover:scale-105"
                    />
                    <div className="flex items-center justify-center">
                        {/* <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">Demo</button> */}
                        <button as="a" href="https://github.com/Pratik0501" className="w-full px-6 py-3 m-4 duration-200 hover:scale-105">Code</button>
                        </div>
                </div>
               
        
            
                    ))}
                    
                   
    
            </div>
    
        </div>

        </div>

      
      )
    }
    
    export default Portfolio